import Axios from "axios";
import * as queryString from "query-string";

const axiosClient = new Axios.create({
    // baseURL:'https://localhost:8080/nem-import/backend/web/api-v1',
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    headers: {
        'Content-Type': "application/json"
    },
    paramsSerializer: params => queryString.stringify(params)
});

axiosClient.interceptors.request.use(async (config) => {

    return config;
});

axiosClient.interceptors.response.use(response => {

    return response;
}, error => {
    throw error
});
export default axiosClient;